<template>
    <div>
        <EmailKB />
    </div>
</template>

<script setup>
import { onBeforeRouteUpdate } from 'vue-router'
import EmailKB from "../../../core/components/email/EmailKB.vue";
onBeforeRouteUpdate(async (to, from, next) => {
  next()
})

</script>

<style lang="scss"></style>